//date日期    fmt 格式化
//函数名可以更改

export function formatDate(date, fmt) {
  //RegExp.$1替换成后面结果
  //date.getFullYear() + ''获取年份转为字符串
  //substr截取，比如输入yy为两位，则length是2，截取为2，.substr（2），年份如果是2021 则前面截取为21
  //此时RegExp.$1替换的值是19  yyyy-MM-dd为 19-MM-dd

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  //利用正则表达式规则获取月，日，时，分，秒，在for处进行统一处理   n+ 匹配任何包含零个或多个 n 的字符串
  let o = {
    'M+': date.getMonth() + 1, //M月 m分钟
    'd+': date.getDate(),
    'h+': date.getHours(), //h为12小时制  H为24小时制
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

//如果发现时间不足两位，给补成两位
//比如传过来是1，length为1 ，先补足为'001',substr截取1位，输出01
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

//数组对象去重
export function uniqueBy(arr, key) {
  const map = new Map();
  const result = [];
  for (const obj of arr) {
    const keyValue = obj[key];
    if (!map.has(keyValue)) {
      map.set(keyValue, obj);
      result.push(obj);
    }
  }
  return result;
}
// 数组转成字符拼接
export function arrToStr(arr) {
  if (Array.isArray(arr)) {
    return arr.join(',');
  }
  return '';
}
//字符拼接转成数组
export function strToArr(str) {
  if (str) {
    return str.toString().split(',');
  }
  return '';
}

//导出格式化数据
export function formatJson(filterVal, jsonData) {
  return jsonData.map((v) =>
    filterVal.map((j) => {
      return v[j];
    })
  );
}

// 生成唯一字符串
export function generateUniqueString() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 11);
}

// 过滤对象无用属性
export function cleanObject(obj) {
  for (const key in obj) {
    if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
      delete obj[key]; // 删除不符合条件的属性
    }
  }
  return obj;
}

/**
 * 比较两个数组的变化
 * @param {Array} oldArray - 原数组
 * @param {Array} newArray - 新数组
 * @param {String} key - 用于唯一标识对象的键
 * @returns {Object} 返回包含新增、删除和保持不变元素的结果
 */
export function watchArrayChange(newArray = [], oldArray = [], key = 'id') {
  const oldMap = new Map();
  const newMap = new Map();

  // 将 oldArray 和 newArray 转为 Map，以便快速查找
  oldArray.forEach((item) => oldMap.set(item[key], item));
  newArray.forEach((item) => newMap.set(item[key], item));

  const added = []; // 新增的元素
  const removed = []; // 删除的元素
  const unchanged = []; // 未改变的元素

  // 检查新增和未改变的元素
  newArray.forEach((item) => {
    if (!oldMap.has(item[key])) {
      added.push(item); // 新增的
    } else {
      unchanged.push(item); // 未改变的
    }
  });

  // 检查删除的元素
  oldArray.forEach((item) => {
    if (!newMap.has(item[key])) {
      removed.push(item); // 删除的
    }
  });

  let rse = {
    added: added,
    removed: removed,
    unchanged: unchanged,
  };

  return rse;
}

/**
 * 比对两个数组，选出相同的元素
 * @param {Array} arr1 - 第一个数组
 * @param {Array} arr2 - 第二个数组
 * @param {String} key - 用于唯一标识对象的键
 * @returns {Array} 返回两个数组中相同的元素
 */
function findSameElements(arr1, arr2, key) {
  const arr2Set = new Set(arr2.map((item) => item[key])); // 将 arr2 转为 Set
  const sameElements = arr1.filter((item) => arr2Set.has(item[key])); // 比对相同元素
  return sameElements;
}
// 获取当前日期
export function getTodayDate(dates) {
  var dd = new Date();
  var n = dates || 0;
  dd.setDate(dd.getDate() + n);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  var d = dd.getDate();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  var day = y + '-' + m + '-' + d;
  return day;
}
// 获取本周开始时间及结束时间
export function getStartAndEndOfWeek() {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const sunday = new Date(now);
  const monday = new Date(now);

  // 获取本周一的日期
  monday.setDate(monday.getDate() - dayOfWeek + 1);
  // 获取本周日的日期
  sunday.setDate(sunday.getDate() - dayOfWeek + 7);

  // 格式化日期为年月日
  function formatDate(date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  return {
    start: formatDate(monday),
    end: formatDate(sunday),
  };
}
// 获取本月开始时间及结束时间
export function getMonthStartEnd() {
  var now = new Date(); // 获取当前日期时间
  var monthStart = new Date(now.getFullYear(), now.getMonth(), 1); // 获取本月第一天的日期时间
  var monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59); // 获取本月最后一天的日期时间（时间为23:59:59）

  // 格式化日期为年月日
  function formatDate(date) {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  return {
    start: formatDate(monthStart),
    end: formatDate(monthEnd),
  };
}
//比较两个数组，从大数组中移除小数组中已存在的对象
export function subtractArrays(largeArray, smallArray, key = 'id') {
  if (smallArray.length == 0) {
    return largeArray;
  }
  // 提取小数组中所有对象的 id
  const smallIds = new Set(smallArray.map((item) => item[key]));

  // 过滤大数组，移除小数组中存在的对象
  const result = largeArray.filter((item) => !smallIds.has(item[key]));

  return result;
}

// arr去重
export function uniqueArr(arr, key) {
  const seen = new Set();
  return arr.filter((item) => {
    const value = item[key];
    if (seen.has(value)) {
      return false;
    } else {
      seen.add(value);
      return true;
    }
  });
}

export function arrDelete(arr, key, val) {
  return arr.filter((item) => item[key] !== val);
}

export function isJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export default {
  formatDate,
  uniqueBy,
  arrToStr,
  strToArr,
  formatJson,
  generateUniqueString,
  cleanObject,
  watchArrayChange,
  findSameElements,
  getTodayDate,
  getStartAndEndOfWeek,
  getMonthStartEnd,
  subtractArrays,
  uniqueArr,
  arrDelete,
  isJSON,
};
